import { mask } from 'ke-the-mask';
import Error from 'custom-error';
import { Money, VMoney } from 'v-money';
import CustomInputDisplay from 'CustomInputDisplay';

//
var script = {
  name: "CustomInput",
  meta: {
    description: "Componente para entrada de datos",
    slots: {
      default: {
        type: "component",
        valid: []
      }
    }
  },
  components: {
    Error,
    CustomInputDisplay,
    Money
  },
  directives: {
    mask,
    money: VMoney
  },
  props: {
    type: {
      type: String,
      default: "text",
      meta: {
        description: "Propiedad type personalizada",
        example: "Texto requerido"
      }
    },
    label: {
      type: String,
      default: "",
      meta: {
        description: "Control para mostrar texto ",
        example: "Texto requerido"
      }
    },
    labelClass: {
      type: String,
      default: "",
      meta: {
        description: "Clases para el label",
        example: "Texto requerido"
      }
    },
    iconBackgroundClass: {
      type: String,
      default: "",
      meta: {
        description: "Clases para el background del icono"
      }
    },
    iconFontClass: {
      type: String,
      default: "",
      meta: {
        description: "Clases para la tipografia del icono"
      }
    },
    errorClass: {
      type: String,
      default: () => ""
    },
    placeholder: {
      type: String,
      default: "",
      meta: {
        description: "Texto de referencia en el input",
        example: "Texto requerido"
      }
    },
    value: {
      type: [String, Number],
      default: "",
      meta: {
        description: "Parámetro de entrada en el input",
        example: "Texto requerido"
      }
    },
    required: {
      type: String,
      default: function () {
        return "";
      },
      meta: {
        description: "Estado requerido",
        example: "required"
      }
    },
    disabled: {
      type: Boolean,
      required: false,
      meta: {
        description: "Estado deshabilitado",
        example: "disabled"
      }
    },
    customDisabled: {
      type: Boolean,
      default: false,
      meta: {
        description: "Esta debera ser la prop para mostrar custom input display",
        // y así dejar el comportamiento habitual de un input para cuando se necesite.
        example: ""
      }
    },
    minlength: {
      type: String,
      default: "",
      meta: {
        description: "Logitud mínima requerida",
        example: "Texto requerido"
      }
    },
    maxlength: {
      type: String,
      default: "",
      meta: {
        description: "Logitud máxima requerida",
        example: "Texto requerido"
      }
    },
    min: {
      type: Number,
      default: 0,
      meta: {
        description: "Límite mínimo  en el input ",
        example: "14"
      }
    },
    max: {
      type: Number,
      default: 100,
      meta: {
        description: "Límite máximo en el input ",
        example: "14"
      }
    },
    step: {
      type: Number,
      default: 1,
      meta: {
        description: "Rango de intervalos ",
        example: "14"
      }
    },
    error: {
      type: String,
      default: "",
      meta: {
        description: "Estado error",
        example: "Texto requerido"
      }
    },
    dirty: {
      type: Boolean,
      default: function () {
        return false;
      },
      meta: {
        description: "Mostrar el checkmark si la validación es correcta",
        example: "true"
      }
    },
    icon: {
      type: String,
      default: "",
      meta: {
        description: "Propiedad para el icono ",
        example: "fas fa-user-edit"
      }
    },
    customErrorMsg: {
      type: String,
      default: null,
      meta: {
        description: "Personalización para mensajes de error",
        example: "Texto requerido"
      }
    },
    maskType: {
      type: String,
      default: "",
      meta: {
        description: "Máscaras del texto",
        example: "Texto requerido"
      }
    },
    masked: {
      type: Boolean,
      default: false,
      meta: {
        description: "Condicional para Enmascarar texto",
        example: "true"
      }
    },
    canModifyCss: {
      type: Boolean,
      default: true,
      meta: {
        description: "Control modificación ",
        example: "true"
      }
    },
    leftIcon: {
      type: Boolean,
      default: () => false,
      meta: {
        description: "Muestra el icono a la izquierda",
        example: "true"
      }
    },
    prependIcon: {
      type: String,
      default: () => null
    },
    prependIconType: {
      type: String,
      default: () => "success"
    },
    prependIconText: {
      type: String,
      default: () => null
    },
    prependIconLeft: {
      type: Boolean,
      default: () => true
    },
    prependIconClick: {
      type: Function,
      default: () => {}
    },
    prependIconColor: {
      type: String,
      default: () => null
    },
    btnTransparent: {
      type: Boolean,
      default: () => false
    },
    btnBorderColor: {
      type: String,
      default: () => null
    }
  },

  data() {
    return {
      maskTypes: [{
        id: "Phone",
        mask: "(###)###-####"
      }, {
        id: "Date",
        mask: "##/##/####"
      }, {
        id: "Zipcode",
        mask: "#####"
      }, {
        id: "PhoneExt",
        mask: "#####"
      }, {
        id: "ZipcodeExt",
        mask: "#####-####"
      }, {
        id: "Day",
        mask: "##"
      }, {
        id: "Personalssn",
        mask: "###-##-####"
      }, {
        id: "Encryptedssn",
        mask: "xxx-xx-####"
      }, {
        id: "Price"
      }, {
        id: "Money"
      }, {
        id: "Coords",
        mask: "##.########"
      }, {
        id: "SieOrSSN",
        mask: "#########"
      }, {
        id: "SSNPatronal",
        mask: "###-######"
      }, {
        id: "SIE",
        mask: "########"
      }, {
        id: "LicenseNumber",
        mask: "###-####"
      }, {
        id: "Journal",
        mask: "######-##"
      }, {
        id: "CreditCard",
        mask: "####-####-####-####"
      }, {
        id: "SieOrSSNorRegistryNumber",
        mask: "##########"
      }, {
        id: "AppointmentNumber",
        mask: "####-######"
      }, {
        id: "BillNumber",
        mask: "AAA-####-AA-###"
      }, {
        id: "ReferralNumber",
        mask: "####-##-######"
      }, {
        id: "Number",
        mask: "#########"
      }],
      inputMask: "",
      formControlClass: "form-control",
      errorMessage: this.customErrorMsg == null ? this.error : this.customErrorMsg,
      moneyValue: this.value,
      ssnInput: {
        loaded: false,
        internalValue: null,
        encryptedValue: null
      }
    };
  },

  computed: {
    isValid() {
      return !this.error && this.dirty;
    },

    computedClassInput() {
      let result = "";

      if (this.error) {
        result = " was-Invalidated";
      } else if (this.isValid && this.canModifyCss) {
        result = " was-validated";
      }

      if (this.leftIcon) {
        result = `${result} leftInput`;
      }

      return this.formControlClass + result;
    },

    computedEmClass() {
      let result = this.icon;

      if (this.leftIcon) {
        result = `${result} left`;
      }

      return result;
    },

    computedIconClass() {
      let result = "form-control-icon-normal far fa-lock-alt";

      if (this.canModifyCss) {
        if (this.isValid) {
          result = "fa fa-checkmark sucess-icon";
        }
      }

      return result;
    },

    inputValue() {
      return this.value;
    }

  },
  watch: {
    error: function (newValue) {
      if (this.customErrorMsg == null) this.errorMessage = newValue;
    },
    customErrorMsg: function (newValue) {
      this.errorMessage = newValue;
    },
    inputValue: {
      handler() {
        if (this.maskType === "Encryptedssn" && !this.ssnInput.loaded) {
          var _this$inputValue;

          this.syncInput((_this$inputValue = this.inputValue) === null || _this$inputValue === void 0 ? void 0 : _this$inputValue.toString());
          this.ssnInput.loaded = !this.ssnInput.loaded;
        }
      },

      immediate: true
    }
  },

  mounted() {
    if (this.maskType != undefined) {
      let mask = this.maskTypes.find(x => x.id == this.maskType);
      this.inputMask = mask != undefined ? mask.mask : "";
    }
  },

  methods: {
    updateValue: function (value) {
      this.$emit("input", value);
    },

    emitValue(value) {
      if (this.maskType == undefined || this.masked) {
        this.$emit("input", value);
        return;
      }

      let sentVal = this.formatMaskedText(value);
      if (sentVal == "") sentVal = null;
      this.$emit("input", sentVal);
    },

    formatMaskedText(value) {
      //conditionals to remove masks from text
      if (this.maskType == "Phone") {
        return value.replace(/-|[()]/gi, "");
      } else if (this.maskType == "Price") {
        if (!isNaN(value)) {
          let val = (value / 1).toFixed(2);
          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "");
        }
      }

      return value;
    },

    transformSsnDisplay(val = "") {
      let displayVal = val.replace(/[^0-9|\\•]/g, "");
      displayVal = displayVal.substr(0, 9);
      if (displayVal.length < 6) return displayVal.replace(/[0-9]/g, "•");else return "•".repeat(5) + val.slice(5);
    },

    transformSsnValue(val) {
      let newValue = this.ssnInput.internalValue ? this.ssnInput.internalValue.toString() : "";
      if (!val) return null;
      let cleanVal = val.replace(/[^0-9|\\•]+5/g, "");
      cleanVal = cleanVal.substr(0, 9);

      for (let i = 0, l = cleanVal.length; i < l; i++) {
        if (/[0-9]/g.exec(cleanVal[i])) newValue = this.replaceAt(newValue, i, cleanVal[i]);
      }

      return newValue.substr(0, cleanVal.length);
    },

    replaceAt(str, index, character) {
      return str.substr(0, index) + character + str.substr(index + character.length);
    },

    syncInput(newValue) {
      this.$nextTick(() => {
        const lengthValue = newValue ? newValue.length : 0;
        this.$refs.encryptedInputRef.setSelectionRange(lengthValue, lengthValue);
        this.ssnInput = { ...this.ssnInput,
          internalValue: this.transformSsnValue(newValue),
          encryptedValue: this.transformSsnDisplay(newValue)
        };
        this.emitValue({ ...this.ssnInput
        });
      });
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm.label && !_vm.disabled ? _c('label', {
    staticClass: "data-label",
    class: _vm.labelClass
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), !_vm.disabled ? _c('div', {
    staticClass: "position-relative",
    class: _vm.prependIcon != null ? 'input-group' : ''
  }, [_vm.prependIcon != null && _vm.prependIconLeft ? _c('div', {
    staticClass: "input-group-prepend",
    class: _vm.prependIconType
  }, [_c('span', {
    staticClass: "input-group-text",
    class: _vm.iconBackgroundClass,
    on: {
      "click": function ($event) {
        return _vm.$emit('prepend-icon-click');
      }
    }
  }, [_c('i', {
    class: _vm.prependIcon
  }), _vm._v(" "), _vm.prependIconText ? _c('span', {
    staticClass: "ml-1",
    class: _vm.iconFontClass
  }, [_vm._v(_vm._s(_vm.prependIconText))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _vm.maskType == 'Money' ? _c('money', {
    staticClass: "form-control",
    class: _vm.computedClassInput,
    on: {
      "input": function ($event) {
        return _vm.$emit('input', _vm.moneyValue);
      }
    },
    model: {
      value: _vm.moneyValue,
      callback: function ($$v) {
        _vm.moneyValue = $$v;
      },
      expression: "moneyValue"
    }
  }) : _vm._e(), _vm._v(" "), _vm.inputMask && _vm.maskType === 'Encryptedssn' ? _c('input', {
    ref: "encryptedInputRef",
    class: _vm.computedClassInput,
    attrs: {
      "type": _vm.type,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "minlength": _vm.minlength,
      "maxlength": _vm.maxlength,
      "step": _vm.step,
      "min": _vm.min,
      "max": _vm.max
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "keyup": function ($event) {
        return _vm.syncInput($event.target.value);
      }
    }
  }) : _vm.inputMask && _vm.maskType !== 'Money' ? _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: _vm.inputMask,
      expression: "inputMask"
    }],
    class: _vm.computedClassInput,
    attrs: {
      "type": _vm.type,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "minlength": _vm.minlength,
      "maxlength": _vm.maxlength,
      "step": _vm.step,
      "min": _vm.min,
      "max": _vm.max
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "blur": function ($event) {
        return _vm.emitValue($event.target.value);
      },
      "keypress": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.$emit('keypress', $event);
      },
      "input": function ($event) {
        return _vm.emitValue($event.target.value);
      },
      "change": function ($event) {
        return _vm.$emit('change', $event.target.value);
      }
    }
  }) : _vm.maskType !== 'Money' ? _c('input', {
    class: _vm.computedClassInput,
    attrs: {
      "type": _vm.type,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "minlength": _vm.minlength,
      "maxlength": _vm.maxlength,
      "step": _vm.step,
      "min": _vm.min,
      "max": _vm.max
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "blur": function ($event) {
        return _vm.emitValue($event.target.value);
      },
      "keypress": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.$emit('keypress', $event);
      },
      "input": function ($event) {
        return _vm.emitValue($event.target.value);
      },
      "change": function ($event) {
        return _vm.$emit('change', $event.target.value);
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.prependIcon != null && !_vm.prependIconLeft ? _c('div', {
    staticClass: "input-group-prepend cursor-pointer",
    class: _vm.prependIconType
  }, [_c('span', {
    class: ['input-group-text', 'rounded-right', {
      'btn-transparent': _vm.btnTransparent
    }, "border-" + _vm.btnBorderColor],
    on: {
      "click": _vm.prependIconClick
    }
  }, [_c('i', {
    class: [_vm.prependIcon, "color-" + _vm.prependIconColor]
  }), _vm._v(" "), _vm.prependIconText ? _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.prependIconText))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _vm.icon && !_vm.error && !_vm.isValid ? _c('em', {
    staticClass: "form-control-icon-normal",
    class: _vm.computedEmClass
  }) : _vm._e(), _vm._v(" "), _vm.isValid ? _c('i', {
    class: _vm.computedIconClass
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.error && !_vm.disabled ? _c('Error', {
    class: _vm.errorClass,
    attrs: {
      "variant": "no-border",
      "message": _vm.errorMessage
    }
  }) : _vm._e(), _vm._v(" "), _vm.disabled ? _c('custom-input-display', {
    attrs: {
      "label": _vm.label,
      "mask-type": _vm.maskType
    },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-69d3a14a_0", {
    source: ".leftInput[data-v-69d3a14a]{padding-left:40px}span.invalid[data-v-69d3a14a]:not(input){color:#e85c5c}.form-control-icon-normal.left[data-v-69d3a14a]{position:absolute;left:15px;top:11px;width:20px}.form-control-icon-invalid[data-v-69d3a14a]{color:#e85c5c;position:absolute;top:9px;right:10px;font-size:19px}.input-label[data-v-69d3a14a]{height:19px;text-align:left;font:Bold 16px/21px Lato!important;letter-spacing:0;color:#11291b;line-height:19px}.form-control[data-v-69d3a14a]:disabled{background:#fff;cursor:not-allowed}.modal-label[data-v-69d3a14a]{font-weight:300;font-family:normal}.custom-error i[data-v-69d3a14a]{float:left;margin-top:15px;margin-right:10px;color:#e85c5c}.was-Invalidated[data-v-69d3a14a]{border:1px solid #ff0018!important}.orange-icon[data-v-69d3a14a]{color:#ff7058}.btn-transparent[data-v-69d3a14a]{background-color:transparent}.cursor-pointer[data-v-69d3a14a]{cursor:pointer}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = "data-v-69d3a14a";
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

// Import vue component

const install = function installCustomInput(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('CustomInput', __vue_component__);
}; // Create module definition for Vue.use()
// to be registered via Vue.use() as well as Vue.component()


__vue_component__.install = install; // Export component by default
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export { __vue_component__ as default };
